/**
 * Point @monaco-editor/react at the self-hosted AMD runtime copied from
 * node_modules/monaco-editor/min/vs (see vite-plugin-monaco.ts).
 * Must run before any Editor / DiffEditor mounts.
 */
import { loader } from '@monaco-editor/react'

export function configureMonacoLoader(): void {
  const vs = `${import.meta.env.BASE_URL}monaco/${__MONACO_VERSION__}/vs`
  loader.config({ paths: { vs } })
}
